// app/src/hooks/useSession.js
import { createContext, useContext } from "react";

/** The session (`useSessionWiring`'s return) `SessionProvider` provides above `AppInner`. */
export const SessionContext = createContext(null);

/** The nearest `SessionProvider`'s session; throws outside one so a missing fixture fails loudly. */
export function useSession() {
  const session = useContext(SessionContext);
  if (session === null) throw new Error("useSession() outside <SessionProvider>");
  return session;
}
